import {
  DELETE_ENTERPRISE,
  DELETE_ENTERPRISE_SUCCESS,
  DELETE_ENTERPRISE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const deleteEnterpriseReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_ENTERPRISE:
      return { ...state, loading: true };
    case DELETE_ENTERPRISE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DELETE_ENTERPRISE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteEnterpriseReducer;
